// assets/js/accommodation.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isEditor = document.body.classList.contains("wp-admin");
if (!isEditor) gsap.registerPlugin(ScrollTrigger);

/* ---------- one section init ---------- */
function initAccommodation(section) {
  if (!section || section.__acInit) return;
  section.__acInit = true;

  const eyebrow = section.querySelector(".accommodation__eyebrow");
  const dot = eyebrow?.querySelector(".dot");
  const headline = section.querySelector(".accommodation__headline");
  const intro = section.querySelector(".accommodation__intro");
  const cta = section.querySelector(".accommodation__cta");
  const photoFig =
    section.querySelector(".accommodation__photo figure") ||
    section.querySelector(".accommodation__photo");
  const photoImg = section.querySelector(".accommodation__photo img");

  // Prep states
  gsap.set([eyebrow, headline, intro, cta], { opacity: 0, y: 20 });
  if (dot) gsap.set(dot, { scale: 0.65 });
  if (photoFig) gsap.set(photoFig, { opacity: 0, y: 16 });
  if (photoImg) gsap.set(photoImg, { scale: 1.06 });

  // Helper: create timeline (editor vs frontend)
  const tlOpts = isEditor
    ? { defaults: { ease: "power3.out" } }
    : {
        defaults: { ease: "power3.out" },
        scrollTrigger: {
          trigger: section,
          start: "top 78%",
          once: true,
        },
      };

  const tl = gsap.timeline(tlOpts);

  // Sequence
  if (photoFig) {
    tl.to(photoFig, { opacity: 1, y: 0, duration: 0.55 });
    if (photoImg)
      tl.to(photoImg, { scale: 1, duration: 0.9, ease: "power2.out" }, "<");
  }

  if (eyebrow) tl.to(eyebrow, { opacity: 1, y: 0, duration: 0.45 }, "-=0.2");
  if (dot) tl.to(dot, { scale: 1, duration: 0.35, ease: "back.out(2)" }, "<");
  if (headline)
    tl.fromTo(
      headline,
      { y: 28, opacity: 0, filter: "blur(3px)" },
      { y: 0, opacity: 1, filter: "blur(0px)", duration: 0.7 }
    );
  if (intro) tl.to(intro, { opacity: 1, y: 0, duration: 0.55 }, "-=0.3");
  if (cta) tl.to(cta, { opacity: 1, y: 0, duration: 0.55 }, "-=0.3");

  // Optional: subtle parallax on photo while in view (frontend only)
  if (!isEditor && photoFig) {
    gsap.to(photoFig, {
      y: -10,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.4,
      },
    });
  }
}

/* ---------- mount ---------- */
const mount = () => {
  if (!isEditor) {
    document.querySelectorAll(".accommodation").forEach(initAccommodation);
    return;
  }
  // In the block editor, observe for inserted/updated blocks
  const root = document.querySelector(".editor-styles-wrapper") || document;
  const run = () =>
    root.querySelectorAll(".accommodation").forEach(initAccommodation);
  run();
  const mo = new MutationObserver(run);
  mo.observe(root, { childList: true, subtree: true });
};

if (window.wp?.domReady) {
  window.wp.domReady(mount);
} else {
  document.addEventListener("DOMContentLoaded", mount);
}
